export default {
  // Page titles
  title: 'ตั้งค่า',
  team: 'ทีม',
  section_label: 'หมวด',

  // Descriptions
  description: 'จัดการการตั้งค่าบัญชี',
  team_description: 'จัดการสมาชิกทีมและบทบาท',

  // Team
  team_section: {
    title: 'สมาชิกทีม',
    invite: 'เชิญสมาชิก',
    invite_description: 'ส่งคำเชิญเข้าร่วมทีม',
    role: 'บทบาท',
    change_role: 'เปลี่ยนบทบาท',
    remove_member: 'ลบสมาชิก',
    resend_invite: 'ส่งคำเชิญอีกครั้ง',
    pending: 'รอตอบรับ',
    login_deleted: 'ลบบัญชีเข้าใช้งานแล้ว',
    login_deleted_note: 'สมาชิกคนนี้ลบบัญชีเข้าใช้งานของตนเอง จะถูกลบถาวรหลังวันที่ {{date}} เจ้าตัวกู้คืนได้เองโดยเข้าสู่ระบบ',
    self_indicator: '(คุณ)',
  },

  // Roles
  roles: {
    owner: 'เจ้าของ',
    admin: 'ผู้ดูแล',
    staff: 'พนักงาน',
    accountant: 'ผู้ทำบัญชี',
  },

  // Invite form
  invite: {
    email: 'อีเมล',
    email_placeholder: 'colleague@example.com',
    first_name: 'ชื่อ',
    last_name: 'นามสกุล',
    role: 'บทบาท',
    send_invite: 'ส่งคำเชิญ',
  },

  // Account
  account: {
    title: 'ตั้งค่าบัญชี',
    name: 'ชื่อบัญชี',
    language: 'ภาษา',
    timezone: 'เขตเวลา',
    date_format: 'รูปแบบวันที่',
    calendar: 'ปฏิทิน',
    currency: 'สกุลเงิน',
    invoice_prefix: 'คำนำหน้าใบแจ้งหนี้',
    invoice_prefix_placeholder: 'เช่น INV',
    liff_id: 'LINE LIFF ID',
    liff_id_placeholder: 'เช่น 1234567890-xxxxxxxx',
    read_only_notice: 'เฉพาะผู้ดูแลและเจ้าของเท่านั้นที่สามารถแก้ไขการตั้งค่าบัญชีได้',
    // EP-160 (section 2.7, S1): the data controller named in the tenants' notice.
    privacy_controller: {
      title: 'ผู้ควบคุมข้อมูลส่วนบุคคล',
      help: 'ผู้เช่าจะเห็นชื่อนี้ในหน้าข้อมูลของฉัน เว้นว่างไว้เพื่อใช้ชื่อบัญชีและอีเมลเจ้าของ',
      name: 'ชื่อผู้ควบคุมข้อมูลส่วนบุคคล',
      contact: 'ช่องทางติดต่อ',
    },
  },

  // Languages
  languages: {
    en: 'English',
    th: 'ไทย',
  },

  // Payment methods
  payment_methods: {
    title: 'วิธีการชำระเงิน',
    description: 'กำหนดวิธีการชำระเงินที่รับจากผู้เช่า',
    bank_transfer: {
      title: 'โอนเงินผ่านธนาคาร',
      description: 'รับชำระผ่านการโอนเงินธนาคาร',
      account_number: 'เลขที่บัญชี',
      account_name: 'ชื่อบัญชี',
      bank_name: 'ธนาคาร',
    },
    promptpay: {
      title: 'พร้อมเพย์',
      description: 'รับชำระผ่าน QR พร้อมเพย์',
      stripe_notice: 'ต้องเชื่อมต่อ Stripe',
      publishable_key: 'Stripe Publishable Key',
      secret_key: 'Stripe Secret Key',
      webhook_secret: 'Stripe Webhook Secret',
    },
    credit_card: {
      title: 'บัตรเครดิต',
      description: 'รับชำระผ่านบัตรเครดิต/เดบิต',
      stripe_notice: 'ต้องเชื่อมต่อ Stripe',
      publishable_key: 'Stripe Publishable Key',
      secret_key: 'Stripe Secret Key',
      webhook_secret: 'Stripe Webhook Secret',
    },
    cash: {
      title: 'เงินสด',
      description: 'รับชำระเงินสดที่สำนักงาน',
    },
    invoice_qr: {
      title: 'QR แบบคงที่',
      description: 'อัปโหลดรูป QR Code (เช่น พร้อมเพย์) เพื่อแสดงบนใบแจ้งหนี้',
      missing: 'ไม่พบรูป QR ที่บันทึกไว้ กรุณาอัปโหลดใหม่',
      upload_failed: 'อัปโหลดรูป QR ไม่สำเร็จ กรุณาลองใหม่',
    },
    coming_soon: 'เร็วๆ นี้',
    groups: {
      basic: 'พื้นฐาน',
      stripe: 'Stripe',
      coming_soon: 'เร็วๆ นี้',
    },
    paysolution: {
      title: 'PaySolution',
      description: 'รับชำระเงินผ่าน PaySolution',
    },
    beam: {
      title: 'Beam',
      description: 'รับชำระเงินผ่าน Beam',
    },
    validation: {
      required: 'จำเป็นต้องกรอกเมื่อเปิดใช้งานวิธีนี้',
    },
    alipay: {
      title: 'Alipay',
      description: 'รับชำระผ่าน Alipay',
    },
    wechat_pay: {
      title: 'WeChat Pay',
      description: 'รับชำระผ่าน WeChat Pay',
    },
    promptpay_bill_payment: {
      title: 'QR แบบไดนามิก',
      description: 'รับชำระผ่าน QR Bill Payment ของพร้อมเพย์โดยใช้รหัส Biller ID จากธนาคาร',
      enabled_label: 'เปิดใช้งาน Bill Payment QR',
      biller_id_label: 'รหัส Biller ID',
      biller_id_helper: 'รหัส Biller ID ของพร้อมเพย์ที่ได้รับจากธนาคาร',
      ref2_mode_label: 'รูปแบบอ้างอิง 2',
      ref2_mode_description: 'กำหนดค่าที่จะเข้ารหัสเป็น Reference 2 ใน QR Bill Payment',
      ref2_mode_plate: 'ป้ายทะเบียน',
      ref2_mode_none: 'ไม่มี',
      proxy_target_label: 'Proxy Target (เบอร์โทรหรือเลขบัตรประชาชน)',
      proxy_target_helper: 'หมายเลข Proxy พร้อมเพย์ที่ลงทะเบียนกับธนาคาร (เบอร์โทรศัพท์หรือเลขบัตรประชาชน 13 หลัก)',
    },
    // EP-143 T143-010 — บัญชีรับเงิน: รายการบัญชีของผู้ดำเนินการที่ผู้เช่า/ผู้จอดรถต้องโอนเงินมา
    receiving_accounts: {
      title: 'บัญชีรับเงิน',
      bank_code_label: 'ธนาคาร',
      account_number_label: 'เลขที่บัญชี',
      display_name_label: 'ชื่อแสดง',
      add_button: 'เพิ่มบัญชี',
      empty: 'ยังไม่ได้ตั้งค่าบัญชีรับเงิน กรุณาเพิ่มอย่างน้อยหนึ่งบัญชีเพื่อให้ระบบตรวจสอบผู้รับเงินในสลิปได้',
    },
  },

  // Tax Invoice Settings
  tax_invoice: {
    title: 'ตั้งค่าใบกำกับภาษี',
    description: 'กำหนดข้อมูลภาษีธุรกิจสำหรับออกใบกำกับภาษี',
    tax_id: 'เลขประจำตัวผู้เสียภาษี (13 หลัก)',
    tax_id_placeholder: '0105XXXXXXXXX',
    branch_number: 'รหัสสาขา',
    branch_number_placeholder: 'เช่น 00000 สำหรับสำนักงานใหญ่',
    address: 'ที่อยู่สำหรับใบกำกับภาษี',
    address_placeholder: 'ที่อยู่สถานประกอบการ',
    vat_enabled: 'รวมภาษีมูลค่าเพิ่ม',
    vat_rate: 'อัตราภาษี (%)',
  },

  // EP-111 T111-6 — สวิตช์เปิดใช้งานโมดูลประเภทอสังหาริมทรัพย์แบบคอนโดมิเนียม (ต่ออสังหาริมทรัพย์)
  // เป็น single-gate (ตั้งค่าระดับบัญชีโดยเจ้าของ/ผู้ดูแล ไม่มี Unleash flag) เมื่อเปิดใช้งาน
  // ฟอร์มอสังหาริมทรัพย์จะแสดงตัวเลือกประเภทอสังหาริมทรัพย์ และเมนู CAF + เจ้าของร่วม
  // จะปรากฏในแถบด้านข้าง (เชื่อมต่อในงานถัดไป)
  property_types: {
    title: 'ประเภทอสังหาริมทรัพย์',
    condominium_enabled_label: 'อสังหาริมทรัพย์แบบคอนโดมิเนียม',
    condominium_enabled_description: 'ให้คุณกำหนดอสังหาริมทรัพย์เป็นคอนโดมิเนียมและเรียกเก็บค่าส่วนกลาง (CAF) ได้ พร้อมเพิ่มเมนูค่าส่วนกลางและเมนูเจ้าของร่วมในแถบด้านข้าง',
  },

  // EP-136 (T136-026) — ค่าเริ่มต้นระดับบัญชีสำหรับการตั้งค่าการจอง
  // แต่ละอสังหาริมทรัพย์สามารถกำหนดค่าแต่ละรายการเองได้ที่บล็อก "การจอง"
  // ในหน้าอสังหาริมทรัพย์ ค่าที่ยังไม่ได้ตั้งที่นี่จะใช้ค่าเริ่มต้นของระบบ
  booking: {
    title: 'ตั้งค่าการจอง',
    description: 'ค่าเริ่มต้นระดับบัญชีที่ใช้เมื่ออสังหาริมทรัพย์ไม่ได้กำหนดค่าการจองของตัวเอง',
    fee_mode_label: 'รูปแบบค่าจอง',
    fee_default_label: 'จำนวนเงินค่าจองเริ่มต้น',
    fee_default_hint: 'เว้นว่างไว้หากต้องการให้กรอกจำนวนเงินทุกครั้งที่จองห้อง',
    forfeit_label: 'ริบค่าจองเมื่อยกเลิก',
    fee_mode_options: {
      deposit: 'เป็นเงินประกัน — นับรวมในเงินประกัน คืนเงินได้',
      revenue: 'เป็นรายได้ — ค่าธรรมเนียมการจองที่ไม่คืนเงิน',
    },
  },


  // Lead Generation Settings
  lead_generation: {
    title: 'สร้างโอกาสขาย',
    description: 'ตั้งค่า LINE สำหรับรับลีดและสร้างผู้สนใจโดยอัตโนมัติ',
    // EP-156 T156-007: การ์ดนี้ใช้ LINE OA เดียวกับแท็บ LINE Integration
    line_oa_status_connected: 'เชื่อมต่อแล้ว · {{name}} ({{basicId}})',
    line_oa_status_not_connected: 'ยังไม่ได้เชื่อมต่อ',
    line_oa_shared_hint: 'ใช้ LINE Official Account เดียวกับ LINE Integration',
    go_to_line_settings: 'ไปที่การตั้งค่า LINE',
  },

  // LPR Settings
  // EP-53: `enabled` key removed; toggle is now admin-cli only.
  // `title` + `description` retained — referenced by LprEventLogPage:146.
  lpr: {
    title: 'ระบบอ่านป้ายทะเบียน (LPR)',
    description: 'เปิดใช้งานระบบอ่านป้ายทะเบียนอัตโนมัติสำหรับจัดการที่จอดรถ',
  },

  // LIFF Settings
  liff: {
    tab_label: 'LINE Integration',
    // EP-156 T156-007 — การ์ด OA ของผู้เช่า (ไม่ใช่ช่องทางของ WIN Pickup)
    line_oa: {
      title: 'LINE Official Account',
      status_connected: 'เชื่อมต่อแล้ว · {{name}} ({{basicId}})',
      status_not_connected: 'ยังไม่ได้เชื่อมต่อ',
      test_connection: 'ทดสอบการเชื่อมต่อ',
      channel_secret: 'Channel Secret',
      channel_secret_placeholder: 'กรอก channel secret',
      channel_secret_configured: 'ตั้งค่าแล้ว วางค่าใหม่เพื่อแทนที่',
      channel_access_token: 'Channel Access Token',
      channel_access_token_placeholder: 'กรอก channel access token',
      channel_access_token_configured: 'ตั้งค่าแล้ว วางค่าใหม่เพื่อแทนที่',
      login_channel_id: 'LINE Login Channel ID',
      login_channel_id_placeholder: 'เช่น 1234567890',
      login_channel_id_hint: 'เติมจากตัวเลขหน้า LIFF ID',
      auto_checks_heading: 'ตรวจอัตโนมัติ (ปุ่มทดสอบ)',
      check_token: 'Token ใช้ได้',
      check_webhook: 'Webhook URL ชี้มาที่ FlowRent',
      check_signature: 'Secret ตรงกับ webhook',
      manual_checks_heading: 'ทำเองใน LINE Developers',
      webhook_url: 'Webhook URL',
      copy: 'คัดลอก',
      copied: 'คัดลอกแล้ว',
      copy_webhook_url: 'คัดลอก webhook URL',
      how_to: 'วิธีทำ',
      manual_step_webhook: 'ใน Messaging API channel เปิด Use webhook แล้ววาง Webhook URL ด้านล่าง',
      manual_step_liff: 'สร้าง LIFF app ใน LINE Login channel ภายใต้ Provider เดียวกับ OA',
      manual_step_linked_oa: 'ใน LINE Login channel ตั้ง Linked OA เป็น OA นี้ และเปิด Add friend option',
    },
    liff_id: 'LIFF ID',
    liff_id_placeholder: 'เช่น 1234567890-xxxxxxxx',
    theme_settings: 'ตั้งค่าธีม',
    login_page_settings: 'หน้าเข้าสู่ระบบ',
    primary_color: 'สีหลัก',
    button_color: 'สีปุ่ม',
    login_bg_color: 'สีพื้นหลังหน้าเข้าสู่ระบบ',
    login_bg_image: 'URL รูปพื้นหลังหน้าเข้าสู่ระบบ',
    login_panel_enabled: 'แสดงแผงด้านหลังฟอร์มเข้าสู่ระบบ',
    login_panel_color: 'สีแผง',
    login_panel_opacity: 'ความทึบของแผง',
    login_title_align: 'การจัดวางหัวข้อ',
    login_title_align_left: 'ชิดซ้าย',
    login_title_align_center: 'กึ่งกลาง',
    login_title_align_right: 'ชิดขวา',
    login_panel_margin: 'ระยะห่างของแผงจากขอบจอ (px, 0 ถึง 48)',
    login_panel_padding: 'ระยะขอบของแผง (px, 0 ถึง 24)',
    login_panel_radius: 'ความโค้งมุมของแผง (px, 0 ถึง 32)',
    login_preview: 'ตัวอย่างหน้าเข้าสู่ระบบ',
    // The LIFF lease-code page's own wording, for the preview. Must equal
    // liff/src/i18n/locales/{en,th}/auth.ts (pinned by a test).
    login_preview_page: {
      title: 'กรอกรหัสสัญญาเช่าเพื่อรับ OTP',
      placeholder: 'เช่น AB123456',
      send_otp: 'ส่ง',
    },
    home_hero_color: 'สีแบนเนอร์หน้าหลัก',
    home_hero_image: 'URL รูปแบนเนอร์หน้าหลัก',
    font_settings: 'ฟอนต์',
    font_family: 'ชื่อฟอนต์ Google',
    font_family_hint: 'ใส่ชื่อฟอนต์จาก Google Fonts (เช่น Bai Jamjuree, Noto Sans Thai, Prompt) เว้นว่างเพื่อใช้ค่าเริ่มต้น',
  },

  // EP-157 T157-005 — แอปมือถือของตัวเอง (white-label) ของบัญชีนั้น เพื่อให้
  // อุปกรณ์ของผู้เช่าที่ใช้แอปนั้นส่งการแจ้งเตือนผ่านโปรเจกต์ Firebase ของ
  // บัญชีเอง ไม่ใช่โปรเจกต์กลางของ FlowRent เฉพาะเจ้าของและผู้ดูแล แสดงให้
  // ทุกบัญชีเห็น พร้อม empty state สำหรับบัญชีที่ใช้แอป FlowRent เฉยๆ
  app_integration: {
    tab_label: 'แอปมือถือ',
    title: 'แอปมือถือของคุณ',
    status_connected: 'เชื่อมต่อแล้ว · ทดสอบล่าสุด {{date}}',
    status_not_connected: 'ยังไม่ได้ทดสอบ',
    test_connection: 'ทดสอบการเชื่อมต่อ',
    name_label: 'ชื่อแอป',
    ios_bundle_id_label: 'iOS Bundle ID',
    android_package_name_label: 'Android Package Name',
    firebase_project_id_label: 'Firebase Project ID',
    service_account_label: 'Service Account Key',
    service_account_configured: 'ตั้งค่าแล้ว ({{email}})',
    service_account_upload_label: 'อัปโหลดไฟล์ .json',
    service_account_replace_label: 'อัปโหลดไฟล์ .json ใหม่เพื่อแทนที่',
    service_account_new_file_selected: 'เลือกไฟล์ใหม่แล้ว: {{filename}}',
    auto_checks_heading: 'ตรวจอัตโนมัติ (ปุ่มทดสอบ)',
    check_key_valid: 'กุญแจใช้ได้',
    check_fcm_reachable: 'ส่งผ่าน Firebase Cloud Messaging ได้',
    manual_checks_heading: 'ทำเองใน Firebase / Apple',
    save: 'บันทึก',
    save_success: 'บันทึกการตั้งค่าแอปมือถือแล้ว',
    remove: 'ลบ',
    remove_confirm_title: 'ลบการตั้งค่าแอปนี้?',
    remove_confirm_message: 'อุปกรณ์ของแอปนี้จะหยุดรับการแจ้งเตือนจนกว่าจะตั้งค่าใหม่',
    remove_confirm_button: 'ลบ',
    remove_success: 'ลบการตั้งค่าแอปมือถือแล้ว',
    how_to: 'วิธีทำ',
    manual_step_apns_key: 'สร้าง APNs key (.p8) ใน Apple Developer → Keys',
    manual_step_apns_upload: 'อัปโหลด APNs key ใน Firebase → Project settings → Cloud Messaging',
    manual_step_service_account: 'สร้าง service account key ใน Firebase → Project settings → Service accounts แล้วอัปโหลดไฟล์ .json ด้านบน',
    manual_step_push_app_id: 'เปิด Push Notifications ให้ App ID ใน Apple Developer → Identifiers',
  },

  // EP-73 C4 — LINE rich menu (เฉพาะเจ้าของ)
  rich_menu: {
    title: 'LINE Rich Menu',
    access_token: 'Channel Access Token',
    token_placeholder: 'วาง channel access token ที่นี่',
    token_configured: 'ตั้งค่าแล้ว วางโทเคนใหม่เพื่อแทนที่',
    save_token: 'บันทึกโทเคน',
    token_saved: 'บันทึก channel access token แล้ว',
    token_save_error: 'ไม่สามารถบันทึกโทเคนได้',
    image: 'รูปภาพ Rich Menu',
    image_hint: 'PNG/JPEG ขนาด 2500×843 px (1 ปุ่ม) หรือ 2500×1686 px (5 ปุ่ม) จะถูกตั้งเป็นเมนูเริ่มต้นสำหรับผู้ใช้ LINE ทุกคน',
    apply: 'ใช้งาน Rich Menu',
    apply_success: 'ตั้งค่า rich menu ให้ LINE Official Account แล้ว',
    apply_error: 'ใช้งาน rich menu ไม่สำเร็จ ตรวจสอบโทเคน, LIFF ID และรูปภาพ',
  },

  // EP-73 — AI feature coach
  ai_coach: {
    title: 'ผู้ช่วยแนะนำฟีเจอร์ (AI)',
    description: 'ผู้ช่วยในแอปที่คอยแนะนำฟีเจอร์ FlowRent ที่ควรตั้งค่าต่อไป พร้อมขั้นตอนสั้น ๆ',
    max_features: 'จำนวนฟีเจอร์สูงสุดที่จะแนะนำ',
    max_features_hint: 'จำนวนฟีเจอร์ที่ผู้ช่วยจะแนะนำได้ตลอดการใช้งาน',
    saved: 'บันทึกการตั้งค่าผู้ช่วยแล้ว',
    save_error: 'บันทึกการตั้งค่าผู้ช่วยไม่สำเร็จ',
  },

  // Parcel Carriers
  parcel_carriers: {
    title: 'ตั้งค่าผู้จัดส่ง',
    description: 'จัดการรายชื่อผู้จัดส่งพัสดุสำหรับเลือกใช้',
    carrier_list: 'รายชื่อผู้จัดส่ง',
    add_carrier: 'เพิ่ม',
    add_placeholder: 'ป้อนชื่อผู้จัดส่ง...',
    reset_defaults: 'รีเซ็ตเป็นค่าเริ่มต้น',
    remove_carrier: 'ลบผู้จัดส่ง',
  },

  // Maintenance Categories
  maintenance_categories: {
    title: 'หมวดหมู่',
    description: 'จัดการหมวดหมู่คำขอแจ้งซ่อม',
    add_placeholder: 'ป้อนชื่อหมวดหมู่...',
    add_placeholder_en: 'ชื่อภาษาอังกฤษ',
    add_placeholder_th: 'ชื่อภาษาไทย',
    add_category: 'เพิ่ม',
    reset_defaults: 'รีเซ็ตเป็นค่าเริ่มต้น',
    remove_category: 'ลบหมวดหมู่',
  },

  // Expense Categories
  expense_categories: {
    title: 'หมวดหมู่ค่าใช้จ่าย',
    description: 'จัดการหมวดหมู่ค่าใช้จ่ายของอสังหาริมทรัพย์',
    add_placeholder_en: 'ชื่อภาษาอังกฤษ',
    add_placeholder_th: 'ชื่อภาษาไทย',
    add_category: 'เพิ่ม',
    reset_defaults: 'รีเซ็ตเป็นค่าเริ่มต้น',
    remove_category: 'ลบหมวดหมู่',
    gl_account_for: 'บัญชีแยกประเภทสำหรับ{{name}}',
    select_gl_account: 'เลือกบัญชีค่าใช้จ่าย',
    loading_gl_accounts: 'กำลังโหลดบัญชีค่าใช้จ่าย…',
    unavailable_gl_account: '{{code}} — บัญชีไม่พร้อมใช้งาน',
    gl_accounts_error: 'โหลดบัญชีค่าใช้จ่ายไม่สำเร็จ กรุณาลองอีกครั้งภายหลัง',
    no_gl_accounts: 'สร้างหรือเปิดใช้งานบัญชีค่าใช้จ่ายในผังบัญชี',
    deposit_return_gl: '2300 — เงินประกันรับ (บัญชีที่กำหนดไว้)',
  },

  // Customer Sources
  customer_sources: {
    title: 'แหล่งที่มาลูกค้า',
    description: 'ตั้งค่าแหล่งที่มาของลูกค้า ตัวเลือกเหล่านี้จะแสดงในฟอร์มลูกค้า',
    add_source: 'เพิ่มแหล่งที่มา',
    key: 'คีย์',
    name_en: 'ชื่อ (EN)',
    name_th: 'ชื่อ (TH)',
    reset_defaults: 'รีเซ็ตเป็นค่าเริ่มต้น',
    no_sources: 'ยังไม่มีแหล่งที่มาลูกค้า',
    add_placeholder_en: 'ชื่อภาษาอังกฤษ',
    add_placeholder_th: 'ชื่อภาษาไทย',
    remove_source: 'ลบแหล่งที่มา',
  },

  // Activity Log
  activity_log: {
    title: 'บันทึกกิจกรรม',
    description: 'ดูประวัติการเปลี่ยนแปลงข้อมูล',
    type_label: 'ประเภท',
    action_label: 'การกระทำ',
    user_label: 'ผู้ใช้',
    all_types: 'ทุกประเภท',
    all_actions: 'ทุกการกระทำ',
    all_users: 'ทุกผู้ใช้',
    date_from: 'ตั้งแต่',
    date_to: 'ถึง',
    empty_title: 'ยังไม่มีกิจกรรม',
    empty_description: 'การเปลี่ยนแปลงข้อมูลจะปรากฏที่นี่',
    record_deleted: 'ลบข้อมูลแล้ว',
    // EP-160 S4: a change made by the FlowRent team in a support session.
    support_actor: 'ทีม FlowRent ({{name}}) · เซสชัน #{{id}}',
    support_actor_no_session: 'ทีม FlowRent ({{name}})',
    removed_value: '[ลบแล้ว]',
    actions: {
      create: 'สร้าง',
      update: 'แก้ไข',
      destroy: 'ลบ',
    },
    model_types: {
      Property: 'อสังหาริมทรัพย์',
      Customer: 'ลูกค้า',
      Unit: 'ห้อง',
      Lease: 'สัญญาเช่า',
      Invoice: 'ใบแจ้งหนี้',
      Payment: 'การชำระเงิน',
      MaintenanceRequest: 'แจ้งซ่อม',
      Parcel: 'พัสดุ',
      RoomType: 'ประเภทห้อง',
      Meter: 'มิเตอร์',
      Reading: 'การจดมิเตอร์',
      DocumentTemplate: 'เทมเพลต',
    },
  },


  // Replay Onboarding
  replay_onboarding: {
    button: 'เริ่มการตั้งค่าใหม่',
    confirm_title: 'เริ่มการตั้งค่าใหม่?',
    confirm_body: 'การดำเนินการนี้จะรีเซ็ตความคืบหน้าการตั้งค่าเริ่มต้น อสังหาริมทรัพย์ ลูกค้า สัญญาเช่า ฯลฯ ที่มีอยู่จะไม่ถูกลบ',
    confirm_yes: 'ใช่ เริ่มใหม่',
  },

  // Activity Log link (admin/owner-only affordance on SettingsPage — F-011)
  activity_log_link: {
    title: 'บันทึกกิจกรรม',
    subtitle: 'ดูว่าใครเปลี่ยนแปลงอะไร',
  },

  // EP-99 WIN pickup relay operator settings (single-gate: win_pickup_enabled)
  win_pickup: {
    tab_label: 'WIN Pickup',
    description: 'ตั้งค่า WIN @winbot LINE group relay สำหรับการแจ้งเตือนรับพัสดุ กรุณาเปิดใช้งานโมดูลนี้จากคอนโซลผู้ดูแลระบบก่อน',

    // Bind code section
    bind_code_title: 'เชื่อมต่อกลุ่ม LINE',
    bind_code_hint: 'ในกลุ่ม LINE ของคุณ พิมพ์ "@winbot connect <รหัส>" พร้อมรหัสนี้เพื่อเชื่อมต่อกลุ่มสำหรับการแจ้งเตือนรับพัสดุ',
    bind_code_label: 'รหัสเชื่อมต่อ',
    copy_bind_code: 'คัดลอกรหัสเชื่อมต่อ',
    copy: 'คัดลอก',
    copied: 'คัดลอกแล้ว!',
    rotate_bind_code: 'สร้างรหัสใหม่',
    rotate_bind_code_hint: 'การสร้างรหัสใหม่จะทำให้รหัสปัจจุบันใช้งานไม่ได้ กลุ่ม LINE จะต้องเชื่อมต่อใหม่หลังจากเปลี่ยนรหัส',
    bind_code_rotated: 'สร้างรหัสเชื่อมต่อใหม่เรียบร้อยแล้ว',
    bind_code_rotate_error: 'ไม่สามารถสร้างรหัสเชื่อมต่อใหม่ได้',

    // Bind status chips
    bind_status: {
      pending_bind: 'รอเชื่อมต่อ',
      active: 'เชื่อมต่อแล้ว',
      inactive: 'ไม่ใช้งาน',
    },

    // LINE OA credentials section
    credentials_title: 'ข้อมูลประจำตัว LINE OA',
    credentials_description: 'กรอกข้อมูลประจำตัว LINE Official Account ของคุณ Access token เป็นแบบเขียนอย่างเดียวและไม่สามารถดึงข้อมูลได้หลังจากบันทึก',
    channel_secret: 'Channel Secret',
    channel_secret_placeholder: 'วาง LINE channel secret ของคุณ',
    channel_secret_configured: 'ตั้งค่าแล้ว วางค่าใหม่เพื่อแทนที่',
    channel_secret_hint: 'พบได้ใน LINE Developers console → Messaging API',
    access_token: 'Channel Access Token',
    access_token_placeholder: 'วาง LINE channel access token ของคุณ',
    access_token_configured: 'ตั้งค่าแล้ว วางค่าใหม่เพื่อแทนที่',
    access_token_hint: 'พบได้ใน LINE Developers console → Messaging API → Channel access token',
    save_credentials: 'บันทึกข้อมูลประจำตัว',
    creds_saved: 'บันทึกข้อมูลประจำตัว LINE แล้ว',
    creds_error: 'ไม่สามารถบันทึกข้อมูลประจำตัว LINE ได้',

    // Fare-board image section
    fare_board_title: 'รูปภาพตารางค่าบริการ',
    fare_board_description: 'อัปโหลดรูปภาพตารางค่าบริการที่แสดงให้ลูกค้าในกลุ่ม LINE (เช่น ตารางค่าส่งพัสดุ)',
    fare_board_preview_alt: 'ตัวอย่างตารางค่าบริการ',
    fare_board_upload_label: 'เลือกรูปภาพตารางค่าบริการ',
    fare_board_uploading: 'กำลังอัปโหลด…',
    fare_board_hint: 'รองรับรูปแบบ: PNG, JPEG, WebP',
    fare_board_saved: 'บันทึกรูปภาพตารางค่าบริการแล้ว',
    fare_board_error: 'ไม่สามารถอัปโหลดรูปภาพตารางค่าบริการได้',
  },

  // EP-144: Settings > Subscription tab (owner-only, read-only)
  subscription: {
    tab_label: 'การสมัครใช้งาน',
    plan: {
      title: 'แพ็กเกจปัจจุบัน',
    },
    tier_label: 'แพ็กเกจ',
    tiers: {
      standard: 'มาตรฐาน',
      invitation: 'บัตรเชิญ',
    },
    statuses: {
      active: 'ใช้งานอยู่',
      canceled: 'ยกเลิกแล้ว',
    },
    billing_cycle_label: 'รอบบิล',
    cycles: {
      monthly: 'รายเดือน',
    },
    started_at_label: 'เริ่มใช้งาน',
    room_count_label: 'จำนวนห้อง',
    next_invoice: {
      title: 'ใบแจ้งหนี้รอบถัดไป (ประมาณการ)',
      period: '{{from}} ถึง {{to}}',
      total: 'รวม',
      note: 'ยอดจริงคำนวณจากจำนวนห้องในวันออกบิล',
    },
    items: {
      subscription_fee: 'ค่าบริการ {{tier}} · {{rooms}} ห้อง',
    },
    pricing: {
      title: 'อัตราค่าบริการ',
      rooms: 'จำนวนห้อง',
      monthly: 'รายเดือน (ต่อห้อง)',
      annual: 'รายปี (ต่อห้อง/ปี)',
      range: '{{min}}-{{max}}',
      range_open: '{{min}}+',
      link: 'ดูรายละเอียดที่ flowrent.io/pricing',
    },
    invoices: {
      title: 'ใบแจ้งหนี้',
      columns: {
        number: 'เลขที่',
        period: 'รอบ',
        rooms: 'ห้อง',
        total: 'ยอดรวม',
        due_at: 'ครบกำหนด',
        status: 'สถานะ',
      },
      status: {
        pending: 'รอชำระ',
        paid: 'ชำระแล้ว',
        void: 'ยกเลิก',
      },
      empty: 'ยังไม่มีใบแจ้งหนี้',
      empty_description: 'ใบแจ้งหนี้รอบแรกจะออกวันที่ 1 ของเดือนถัดไป',
    },
    invoice_detail: {
      items: 'รายการค่าบริการ',
      columns: {
        description: 'รายละเอียด',
        quantity: 'จำนวน',
        unit_price: 'ราคาต่อหน่วย',
        amount: 'จำนวนเงิน',
      },
      subtotal: 'ยอดรวมย่อย',
      details: 'ข้อมูลใบแจ้งหนี้',
      period_range: 'ช่วงรอบบิล',
      emailed_at: 'ส่งอีเมลเมื่อ',
      not_emailed: 'ยังไม่ได้ส่งอีเมล',
      payment: 'การชำระเงิน',
      payment_amount: 'ยอดที่ชำระ',
      paid_at: 'ชำระเมื่อ',
      payment_method: 'ช่องทาง',
      payment_methods: {
        transfer: 'โอนเงิน',
        promptpay: 'พร้อมเพย์',
        other: 'อื่น ๆ',
      },
      no_payment: 'ยังไม่มีการบันทึกการชำระเงิน',
      not_found: 'ไม่พบใบแจ้งหนี้นี้',
      back: 'กลับไปหน้าการสมัครใช้งาน',
    },
    none: {
      title: 'ยังไม่มีการตั้งค่าแพ็กเกจ',
      description: 'ติดต่อทีมงาน FlowRent เพื่อเปิดใช้งาน',
    },
    errors: {
      load_failed: 'โหลดข้อมูลการสมัครใช้งานไม่สำเร็จ',
    },
  },

  // EP-160 T160-201w: Settings -> ความช่วยเหลือจาก FlowRent (S2) เจ้าของบัญชี
  // อนุญาตให้ทีม FlowRent เข้ามาช่วยชั่วคราว ผู้ดูแลเห็นแบบอ่านอย่างเดียว
  support_access: {
    tab_label: 'ความช่วยเหลือจาก FlowRent',
    title: 'ความช่วยเหลือจาก FlowRent',
    intro_1: 'ให้ทีม FlowRent เข้ามาช่วยในบัญชีของคุณได้ชั่วคราว',
    intro_2: 'ทุกการเปลี่ยนแปลงถูกบันทึกและแสดงในประวัติด้านล่าง',
    intro_3: 'การเปิดดูข้อมูลผู้เช่าแบบเต็มถูกบันทึกเป็นรายคน',
    intro_4: 'ทีม FlowRent ไม่เห็นเลขบัตรประชาชน รูปสลิป รูปบัตร หรือบัญชีธนาคาร ไม่ว่ากรณีใด',
    admin_read_only: 'เฉพาะเจ้าของบัญชีที่อนุญาตหรือยกเลิกการอนุญาตได้',
    load_failed: 'โหลดการตั้งค่าความช่วยเหลือจาก FlowRent ไม่สำเร็จ',
    none_active: 'ขณะนี้ทีม FlowRent ไม่มีสิทธิ์เข้าบัญชีนี้',
    unknown_staff: 'ไม่ระบุชื่อ',
    scopes: {
      read: 'ดูอย่างเดียว',
      setup: 'ตั้งค่าให้ฉัน',
      tenants: 'ตั้งค่าและกรอกผู้เช่าให้ฉัน',
    },
    scope_notes: {
      read: 'ดูได้แต่แก้ไขไม่ได้ เห็นข้อมูลผู้เช่าแบบปิดบังบางส่วน',
      setup: 'อาคาร ห้อง ราคา การตั้งค่า เห็นข้อมูลผู้เช่าแบบปิดบังบางส่วน เช่น ส••• 08x-xxx-5678',
      tenants: 'เห็นชื่อ เบอร์ อีเมล และที่อยู่ผู้เช่าเต็ม ทุกครั้งที่เปิดดูจะถูกบันทึก',
    },
    form: {
      instruction_label: 'สิ่งที่ต้องการให้ทีม FlowRent ทำ',
      instruction_placeholder: 'เช่น นำเข้าห้องของอาคาร A จากไฟล์ที่ส่งให้ทาง LINE',
      instruction_required: 'กรุณาเขียนสิ่งที่ต้องการให้ทีม FlowRent ทำ',
      scope_label: 'ขอบเขต',
      buildings_label: 'เฉพาะอาคาร',
      all_buildings: 'ทุกอาคาร',
      some_buildings: 'เลือกอาคาร',
      buildings_required: 'เลือกอย่างน้อยหนึ่งอาคาร',
      no_buildings: 'ยังไม่มีอาคารในบัญชีนี้',
      duration_label: 'ระยะเวลา',
      days_one: '{{count}} วัน',
      days_other: '{{count}} วัน',
      submit: 'อนุญาต',
      approve_hint: 'เลือกขอบเขตและระยะเวลาด้านล่างแล้วกดอนุญาต หรือปฏิเสธคำขอ',
    },
    grant: {
      active_prefix: 'อนุญาตแล้ว',
      signup_prefix: 'อนุญาตตอนสมัคร',
      expires: 'หมดอายุ {{date}}',
      buildings_count_one: '{{count}} อาคาร',
      buildings_count_other: '{{count}} อาคาร',
      instruction: 'สิ่งที่ขอ: “{{text}}”',
      revoke: 'ยกเลิกการอนุญาต',
      revoke_confirm_title: 'ยกเลิกการอนุญาตหรือไม่',
      revoke_confirm_body: 'ทีม FlowRent จะเข้ามาทำงานในบัญชีนี้ไม่ได้อีกจนกว่าคุณจะอนุญาตใหม่',
      revoke_confirm_yes: 'ยกเลิกการอนุญาต',
      revoked: 'ยกเลิกการอนุญาตแล้ว',
      created: 'อนุญาตให้ทีม FlowRent ช่วยในบัญชีแล้ว',
    },
    request: {
      line: 'คำขอจากทีม FlowRent ({{name}}): “{{reason}}” · เสนอขอบเขต {{scope}}',
      expires_in_one: 'หมดอายุใน {{count}} ชม.',
      expires_in_other: 'หมดอายุใน {{count}} ชม.',
      decline: 'ปฏิเสธ',
      declined: 'ปฏิเสธคำขอแล้ว',
      deep_link_gone: 'คำขอในลิงก์หมดอายุหรือได้รับคำตอบแล้ว',
    },
    history: {
      title: 'ประวัติ',
      empty: 'ทีม FlowRent ยังไม่เคยเข้ามาทำงานในบัญชีนี้',
      load_failed: 'โหลดประวัติไม่สำเร็จ',
      started: 'ทีม FlowRent ({{name}}) เริ่มเซสชัน',
      ended_one: 'ทีม FlowRent ({{name}}) จบเซสชัน ({{count}} รายการ)',
      ended_other: 'ทีม FlowRent ({{name}}) จบเซสชัน ({{count}} รายการ)',
      in_progress: 'กำลังทำงาน',
      show_details: 'ดูรายละเอียด',
      hide_details: 'ซ่อนรายละเอียด',
      details_failed: 'โหลดรายละเอียดของเซสชันนี้ไม่สำเร็จ',
      no_changes: 'เซสชันนี้ไม่มีการเปลี่ยนแปลง',
      event_read: 'ทีม FlowRent ({{name}}) ดูข้อมูล',
      event_write: 'ทีม FlowRent ({{name}}) แก้ไขข้อมูล',
      event_subjects_one: 'ผู้เช่า {{count}} คน',
      event_subjects_other: 'ผู้เช่า {{count}} คน',
      more_events: 'แสดง {{shown}} จาก {{total}} รายการ',
      case_reason: 'เรื่อง: {{reason}}',
      case_ticket: 'เลขอ้างอิง {{ref}}',
    },
    summary: {
      create: 'สร้าง{{resource}} {{count}}',
      import: 'นำเข้า{{resource}} {{count}}',
      update: 'แก้ไข{{resource}} {{count}}',
      destroy: 'ลบ{{resource}} {{count}}',
      resources: {
        account: 'การตั้งค่าบัญชี',
        property: 'อาคาร',
        room_type: 'ประเภทห้อง',
        unit: 'ห้อง',
        meter: 'มิเตอร์',
        reading: 'ค่ามิเตอร์',
        customer: 'ผู้เช่า',
        lease: 'สัญญา',
        invoice: 'ใบแจ้งหนี้',
        invoice_item: 'รายการในใบแจ้งหนี้',
        payment: 'การชำระเงิน',
        expense: 'ค่าใช้จ่าย',
        vendor: 'ผู้ขาย',
        equipment: 'อุปกรณ์',
        maintenance_request: 'งานแจ้งซ่อม',
        maintenance_schedule: 'แผนบำรุงรักษา',
        work_order: 'ใบสั่งงาน',
        parcel: 'พัสดุ',
        vehicle: 'รถ',
        document_template: 'แม่แบบเอกสาร',
        gl_account: 'ผังบัญชี',
        journal_entry: 'รายการบัญชี',
        fixed_asset: 'สินทรัพย์',
        parking_zone: 'โซนจอดรถ',
        user: 'ผู้ใช้งาน',
        file: 'ไฟล์',
        other: 'รายการอื่น',
      },
    },
    errors: {
      owner_email_recently_changed: 'อีเมลเจ้าของบัญชีเพิ่งถูกเปลี่ยนภายใน 72 ชั่วโมง กรุณาลองใหม่หลังจากนั้น',
      grant_active: 'ทีม FlowRent มีสิทธิ์อยู่แล้ว ยกเลิกการอนุญาตเดิมก่อนจึงจะอนุญาตใหม่ได้',
      request_expired: 'คำขอนี้หมดอายุแล้ว ทีม FlowRent ส่งคำขอใหม่ได้',
      request_not_pending: 'คำขอนี้ได้รับคำตอบแล้ว',
      invalid_property_ids: 'มีอาคารที่เลือกซึ่งไม่อยู่ในบัญชีนี้แล้ว',
      instruction_required: 'กรุณาเขียนสิ่งที่ต้องการให้ทีม FlowRent ทำ',
      instruction_too_long: 'เขียนได้ไม่เกิน 1,000 ตัวอักษร',
      grant_not_found: 'ไม่มีการอนุญาตที่ต้องยกเลิก',
    },
  },

  // EP-160 T160-104w: Settings -> คำขอข้อมูลส่วนบุคคล (owner and admin)
  data_requests: {
    tab_label: 'คำขอข้อมูลส่วนบุคคล',
    title: 'คำขอข้อมูลส่วนบุคคล',
    description: 'คำขอจากผู้เช่าตามสิทธิของเจ้าของข้อมูลส่วนบุคคล ต้องตอบภายใน 30 วันนับจากวันที่ขอ',
    empty: 'ยังไม่มีคำขอ',
    load_failed: 'โหลดคำขอไม่สำเร็จ',
    unknown_customer: 'ไม่ทราบชื่อ',
    columns: {
      customer: 'ผู้เช่า',
      type: 'ประเภท',
      requested_at: 'ขอเมื่อ',
      due_at: 'ครบกำหนด',
      status: 'สถานะ',
      note: 'ข้อความ',
      actions: 'ดำเนินการ',
    },
    types: {
      access: 'สำเนาข้อมูล',
      erasure: 'ลบข้อมูล',
      rectification: 'แก้ไขข้อมูล',
      restriction: 'ระงับการใช้ข้อมูล',
      objection: 'คัดค้าน',
      withdrawal: 'ถอนความยินยอม',
    },
    statuses: {
      pending: 'รออนุมัติ',
      processing: 'รอดำเนินการ',
      completed: 'อนุมัติแล้ว',
      rejected: 'ปฏิเสธแล้ว',
      link_sent: 'ส่งลิงก์แล้ว',
    },
    decision_note: 'เหตุผล: {{note}}',
    approve: 'อนุมัติ',
    reject: 'ปฏิเสธ',
    approved: 'อนุมัติคำขอแล้ว',
    approved_access: 'อนุมัติแล้ว ระบบจะส่งลิงก์ดาวน์โหลดให้ผู้เช่า',
    rejected: 'ปฏิเสธคำขอแล้ว',
    erasure_confirm_title: 'อนุมัติการลบข้อมูล?',
    erasure_confirm_body: 'ข้อมูลส่วนบุคคลของ {{name}} จะถูกลบและย้อนกลับไม่ได้ ใบแจ้งหนี้และการชำระเงินยังเก็บไว้ตามกฎหมาย โดยไม่มีชื่อผู้เช่า',
    erasure_confirm_yes: 'ลบข้อมูล',
    reject_title: 'ปฏิเสธคำขอ',
    reject_body: 'ระบุเหตุผลที่ปฏิเสธคำขอของ {{name}} เหตุผลจะถูกบันทึกไว้กับคำขอ',
    reject_reason_label: 'เหตุผล',
    reject_reason_required: 'กรุณาระบุเหตุผล',
    reject_confirm: 'ปฏิเสธคำขอ',
    lift: 'ยกเลิกการจำกัด',
    lift_title: 'ยกเลิกการจำกัดการใช้ข้อมูล',
    lift_body: 'ระบุเหตุผลที่ยกเลิกการจำกัดข้อมูลของ {{name}} เหตุผลและผู้ยกเลิกจะถูกบันทึกไว้กับคำขอ',
    lift_reason_label: 'เหตุผล',
    lift_reason_required: 'กรุณาระบุเหตุผล',
    lift_confirm: 'ยกเลิกการจำกัด',
    lifted: 'ยกเลิกการจำกัดแล้ว',
    lifted_still_restricted: 'ยกเลิกแล้ว แต่ {{name}} ยังถูกจำกัดตามคำขออื่นที่อนุมัติไว้',
    lifted_note: 'ยกเลิกการจำกัดเมื่อ {{date}}: {{reason}}',
    errors: {
      request_already_decided: 'คำขอนี้ถูกตัดสินไปแล้ว',
      invalid_status: 'สถานะที่ส่งไม่ถูกต้อง',
      note_too_long: 'เหตุผลยาวเกิน 1,000 ตัวอักษร',
      request_not_liftable: 'ยกเลิกการจำกัดนี้ไม่ได้ (ยังไม่ได้อนุมัติหรือยกเลิกไปแล้ว)',
      lift_reason_required: 'กรุณาระบุเหตุผล',
      lift_reason_too_long: 'เหตุผลยาวเกิน 1,000 ตัวอักษร',
    },
  },

  // EP-160 T160-104w: Settings -> ลบบัญชี, the owner's "download all data"
  delete_account: {
    export_title: 'ดาวน์โหลดข้อมูลทั้งหมด',
    export_body: 'รับสำเนาข้อมูลทั้งหมดของบัญชีก่อนลบบัญชี เราจะส่งลิงก์ดาวน์โหลดไปที่อีเมลเจ้าของบัญชีเท่านั้น',
    export_button: 'ดาวน์โหลดข้อมูลทั้งหมด',
    export_requested: 'เราจะส่งลิงก์ไปที่อีเมลเจ้าของบัญชี',
    export_owner_email_recently_changed: 'อีเมลเจ้าของบัญชีเพิ่งเปลี่ยนภายใน 72 ชั่วโมง ขอดาวน์โหลดได้อีกครั้งเมื่อพ้นช่วงนี้',
    export_in_progress: 'กำลังเตรียมข้อมูลชุดก่อนหน้าอยู่ เราจะส่งลิงก์ไปที่อีเมลเจ้าของบัญชีเมื่อเสร็จ',
  },

  // Actions
  actions: {
    save_settings: 'บันทึกการตั้งค่า',
  },

  // Messages
  messages: {
    invite_sent: 'ส่งคำเชิญสำเร็จ',
    invite_resent: 'ส่งคำเชิญอีกครั้งเรียบร้อยแล้ว',
    role_updated: 'เปลี่ยนบทบาทสำเร็จ',
    member_removed: 'ลบสมาชิกสำเร็จ',
    remove_confirm: 'ลบ {{name}} ออกจากทีม?',
    cannot_remove_self: 'คุณไม่สามารถลบตัวเองออกจากทีมได้',
    settings_saved: 'บันทึกการตั้งค่าสำเร็จ',
    // PAY-1 (T149-082/083/084): shown instead of a success toast when a
    // save did not actually happen: a client validation stop or a server
    // failure. See SettingsSaveAlert.
    not_saved: 'ยังไม่ได้บันทึก',
    not_saved_field_count_one: 'ยังไม่ได้บันทึก มี {{count}} ช่องที่ต้องแก้ไข',
    not_saved_field_count_other: 'ยังไม่ได้บันทึก มี {{count}} ช่องที่ต้องแก้ไข',
  },

  // EP-156 T156-007 / EP-157 T157-005
  errors: {
    line_not_configured: 'บันทึก channel secret และ access token ก่อน',
    line_token_invalid: 'LINE ไม่ยอมรับ channel access token ที่บันทึกไว้',
    webhook_not_flowrent: 'webhook URL ที่ลงทะเบียนไว้กับ LINE ไม่ใช่ FlowRent ชุดนี้',
    webhook_signature_failed: 'การทดสอบ webhook ของ LINE ไม่ผ่าน channel secret ที่บันทึกไว้อาจไม่ถูกต้อง',
    app_id_required: 'ต้องระบุ iOS Bundle ID หรือ Android Package Name อย่างน้อยหนึ่งอย่าง',
    app_id_taken: 'แอปนี้ถูกลงทะเบียนไว้กับบัญชีอื่นแล้ว',
    app_id_reserved: 'ไม่สามารถใช้ไอดีแอปของ FlowRent เองได้',
    service_account_invalid: 'ไฟล์นี้ไม่ใช่ไฟล์ Firebase Service Account ที่ถูกต้อง',
    service_account_project_mismatch: 'ไฟล์นี้เป็นของโปรเจกต์ Firebase คนละตัวกับที่กรอกไว้',
    encryption_not_configured: 'ระบบยังไม่พร้อมเก็บกุญแจในสภาพแวดล้อมนี้',
    app_integration_key_invalid: 'Firebase ปฏิเสธ service account key ที่บันทึกไว้',
    app_integration_fcm_unreachable: 'ไม่สามารถเชื่อมต่อ Firebase Cloud Messaging ของโปรเจกต์นี้ได้',
  },
}
